import { Injectable } from '@angular/core';

@Injectable()
export class LocalizationServiceConfig {
  public locale_id = '';
}
